<div class="page-wrap height-100 black">
    <div class="session-form-hold">
        <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
        <mat-card>
            <mat-card-content>
                <div class="text-center pt-8 pb-16">
                    <img width="240px" src="assets/images/icon-euprava.png" alt="" class="mb-05">
                </div>
                <div>
                    <button mat-flat-button class="mat-primary full-width" (click)="login()">
                        Пријава
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>